import type { ComponentProps } from "react"
import type { VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
import { Textarea as TextareaBase } from "./base/TextareaBase"
import { textareaBaseVariants } from "./base/textarea.base.constants"

export type TextareaProps = ComponentProps<typeof TextareaBase> &
  VariantProps<typeof textareaBaseVariants>

function Textarea(props: TextareaProps) {
  const { className, size, variant, ...textareaBaseProps } = props
  return (
    <TextareaBase
      className={cn(
        "ui-textarea",
        textareaBaseVariants({ size, variant, className }),
      )}
      {...textareaBaseProps}
    />
  )
}

export default Textarea
